import React, { useEffect, useRef } from "react";
import { SectionTitle } from "./SubscriptionPage.styles";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import AllSubs from "../../../components/Subscriptions/AllSubs";
import ViewMoreSubscribers from "../../../components/Subscriptions/ViewMoreSubscribers";
import { getAdminSubscriptions } from "../../../store/slices/subscriptions/asyncThunks";
import { selectedSubscriptions } from "../../../store/slices/subscriptions/slice";
import { selectedLocale } from "../../../store/slices/common/slice";
import openToast from "../../../utils/toast";

const SubscriptionPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const expired = queryParams.get("expired");
  const subscriptions = useSelector(selectedSubscriptions);
  const toastId = useRef(null);

  useEffect(() => {
    dispatch(getAdminSubscriptions())
      .unwrap()
      .catch((err) =>
        openToast(toastId, "error-admin-subs", "error", t(err.message))
      );
  }, [dispatch]);

  const onClickMoreChurned = () => {
    const query = { page: 1, search: "", expired: true };
    const queryString = new URLSearchParams(query).toString();
    const url = `/admin-portal/subscriptions?${queryString}`;

    navigate(url);
  };

  const onClickMoreSubscriptions = () => {
    const query = { page: 1, search: "", expired: false };
    const queryString = new URLSearchParams(query).toString();
    const url = `/admin-portal/subscriptions?${queryString}`;

    navigate(url);
  };
  const onClickMoreBankTransfers = () => {
    const query = { page: 1 };
    const queryString = new URLSearchParams(query).toString();
    const url = `/admin-portal/subscriptions/bank-transfers?${queryString}`;

    navigate(url);
  };

  const locale = useSelector(selectedLocale);

  const ar = locale === "ar";

  return (
    <>
      <SectionTitle>{t("subscriptions")}</SectionTitle>
      {expired === null && (
        <AllSubs
          data={subscriptions}
          ar={ar}
          onClickMoreBankTransfers={onClickMoreBankTransfers}
          onClickMoreChurned={onClickMoreChurned}
          onClickMoreSubscriptions={onClickMoreSubscriptions}
        />
      )}
      {expired && (
        <ViewMoreSubscribers
          ar={ar}
          onBack={() => navigate("/admin-portal/subscriptions")}
        />
      )}
    </>
  );
};

export default SubscriptionPage;
